import { AxiosError } from 'axios';

const INVALID_TOKENS_ERRORS = [
  // Core BE
  'token_is_not_present',
  'token_has_invalid_signature',
  'token_is_invalid',
  'token_has_no_permission',
  'token_has_invalid_issuer',
  'token_has_invalid_audience',
  'invalid_token',
  'bearer_not_present',
  // Auth
  'JWT_malformed',
  'JWT_is_invalid',
  'JWT_invalid_signature',
  'JWT_audience_invalid',
  'JWT_issuer_invalid',
  'JWT_is_invalid',
  'Invalid_token',
  // User was blocked on auth
  'blocked_user',
] as const;

const REFRESH_TOKEN_STATUSES = [400, 401];
const REFRESH_TOKENS_ERRORS = [
  // Crypto BE
  'Signature has expired.',
  // Core BE
  'JWT_expired',
  'jwt_expired',
  // Nft BE
  'token_is_expired',
] as const;

function getErrorMessage(error: NonNullable<AxiosError['response']>) {
  const { data } = error;

  return (
    data?.data?.errCode ??
    data?.message ??
    data?.message_code ??
    data?.messageCode ??
    data?.detail ??
    data?.errCode
  );
}

/**
 * Check if error is about token expiration
 * @param error error form api
 * @returns if we can refresh token
 */
export function isTokenExpired(error: NonNullable<AxiosError['response']>) {
  const { status } = error;

  /** Check for error code */
  const matchStatus = REFRESH_TOKEN_STATUSES.includes(status);

  /** Extract error from multiple services */
  const errorMessage = getErrorMessage(error);
  /** Check if we can refresh token */
  const matchError = errorMessage && REFRESH_TOKENS_ERRORS.includes(errorMessage);

  /** Check for whole condition */
  return matchStatus && matchError;
}

/**
 * Check if tokens are invalid for instance
 * @param error axios error
 * @returns boolean
 */
export function isTokenInvalid(error: NonNullable<AxiosError['response']>) {
  /** Extract error from multiple services */
  const errorMessage = getErrorMessage(error);

  return errorMessage && INVALID_TOKENS_ERRORS.includes(errorMessage);
}
